import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusEncounterFragment = { readonly __typename?: 'SyncableEpocusEncounter', readonly id: string, readonly elephantPatientId?: string | null, readonly patientName?: string | null, readonly patientDob?: string | null, readonly patientGender?: string | null, readonly operatorName?: string | null, readonly accessionNumber?: string | null, readonly dicomStudyId?: string | null, readonly status: Types.EpocusEncounterStatus, readonly performerId?: string | null, readonly programId?: string | null, readonly deviceName?: string | null, readonly deviceSerialNumber?: string | null, readonly location?: string | null, readonly encounterDate?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusEncounterPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusEncounterInput;
}>;


export type SyncEpocusEncounterPullQuery = { readonly __typename?: 'Query', readonly pullEpocusEncounter: { readonly __typename?: 'PullEpocusEncounterResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusEncounter', readonly id: string, readonly elephantPatientId?: string | null, readonly patientName?: string | null, readonly patientDob?: string | null, readonly patientGender?: string | null, readonly operatorName?: string | null, readonly accessionNumber?: string | null, readonly dicomStudyId?: string | null, readonly status: Types.EpocusEncounterStatus, readonly performerId?: string | null, readonly programId?: string | null, readonly deviceName?: string | null, readonly deviceSerialNumber?: string | null, readonly location?: string | null, readonly encounterDate?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusEncounterPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusEncounterInput;
}>;


export type SyncEpocusEncounterPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusEncounter: { readonly __typename?: 'PushEpocusEncounterResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusEncounter', readonly id: string, readonly elephantPatientId?: string | null, readonly patientName?: string | null, readonly patientDob?: string | null, readonly patientGender?: string | null, readonly operatorName?: string | null, readonly accessionNumber?: string | null, readonly dicomStudyId?: string | null, readonly status: Types.EpocusEncounterStatus, readonly performerId?: string | null, readonly programId?: string | null, readonly deviceName?: string | null, readonly deviceSerialNumber?: string | null, readonly location?: string | null, readonly encounterDate?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusEncounterFragmentDoc = gql`
    fragment WholeSyncableEpocusEncounter on SyncableEpocusEncounter {
  id
  elephantPatientId
  patientName
  patientDob
  patientGender
  operatorName
  accessionNumber
  dicomStudyId
  status
  performerId
  programId
  deviceName
  deviceSerialNumber
  location
  encounterDate
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusEncounterPullDocument = gql`
    query SyncEpocusEncounterPull($input: PullEpocusEncounterInput!) {
  pullEpocusEncounter(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusEncounter
    }
  }
}
    ${WholeSyncableEpocusEncounterFragmentDoc}`;

/**
 * __useSyncEpocusEncounterPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusEncounterPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusEncounterPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusEncounterPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusEncounterPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusEncounterPullQuery, SyncEpocusEncounterPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusEncounterPullQuery, SyncEpocusEncounterPullQueryVariables>(SyncEpocusEncounterPullDocument, options);
      }
export function useSyncEpocusEncounterPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusEncounterPullQuery, SyncEpocusEncounterPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusEncounterPullQuery, SyncEpocusEncounterPullQueryVariables>(SyncEpocusEncounterPullDocument, options);
        }
export type SyncEpocusEncounterPullQueryHookResult = ReturnType<typeof useSyncEpocusEncounterPullQuery>;
export type SyncEpocusEncounterPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusEncounterPullLazyQuery>;
export type SyncEpocusEncounterPullQueryResult = Apollo.QueryResult<SyncEpocusEncounterPullQuery, SyncEpocusEncounterPullQueryVariables>;
export const SyncEpocusEncounterPushDocument = gql`
    mutation SyncEpocusEncounterPush($input: PushEpocusEncounterInput!) {
  pushEpocusEncounter(input: $input) {
    rows {
      ...WholeSyncableEpocusEncounter
    }
  }
}
    ${WholeSyncableEpocusEncounterFragmentDoc}`;
export type SyncEpocusEncounterPushMutationFn = Apollo.MutationFunction<SyncEpocusEncounterPushMutation, SyncEpocusEncounterPushMutationVariables>;

/**
 * __useSyncEpocusEncounterPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusEncounterPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusEncounterPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusEncounterPushMutation, { data, loading, error }] = useSyncEpocusEncounterPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusEncounterPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusEncounterPushMutation, SyncEpocusEncounterPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusEncounterPushMutation, SyncEpocusEncounterPushMutationVariables>(SyncEpocusEncounterPushDocument, options);
      }
export type SyncEpocusEncounterPushMutationHookResult = ReturnType<typeof useSyncEpocusEncounterPushMutation>;
export type SyncEpocusEncounterPushMutationResult = Apollo.MutationResult<SyncEpocusEncounterPushMutation>;
export type SyncEpocusEncounterPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusEncounterPushMutation, SyncEpocusEncounterPushMutationVariables>;